export const ReplyToCommentActionTypes = {
    OPEN_REPLY_TO_COMMENT_PAGE: 'OPEN_REPLY_TO_COMMENT_PAGE',
    CLOSE_REPLY_TO_COMMENT_PAGE: 'CLOSE_REPLY_TO_COMMENT_PAGE'
};